module.exports = "//public.getcloudapp.com/packs/media/images/upload-drop-5c3aa71952bc953e4bbdad21259cf131.svg";